export default __webpack_public_path__ + "static/media/Group9187.ea9a2fa5.svg";